module.exports = __webpack_public_path__ + "static/media/dummyUser.6aecef17.png";